import { jsxs as g, jsx as t } from "react/jsx-runtime";
import { Row as A } from "antd";
import { memo as M } from "react";
import { u as m } from "../../../styled-components.browser.esm-BFmoFexH.js";
import { useHasGrowthApplied as O, useHasFilterApplied as F, useHasPeriodApplied as y, useHasDisplayOptionApplied as H } from "../../../metricDisplay/MetricDisplay.hooks.js";
import { l as j } from "../../../lodash-DeBCDn4U.js";
import { M as l } from "../../../MetricGrowthResume-ClJnPTa-.js";
import G from "./MetricPeriodResume.js";
import C from "./MetricFiltersResume.js";
import E from "./MetricDisplayResume.js";
const T = M(({
  value: r,
  setActiveKey: i,
  onDelete: o,
  timeInterval: d,
  dayDifference: e,
  isNameDisplayed: f = !1,
  iconSize: s = 16,
  additionnalStyle: h,
  hideDisplayOptions: n = !1,
  iconSpan: p = 1
}) => {
  const x = O({ growth: r == null ? void 0 : r.growth }), c = F({ additionalFilters: (r == null ? void 0 : r.additionalFilters) ?? [] }), w = y({ overridePeriod: r == null ? void 0 : r.overridePeriod }), P = H({
    extraConf: r == null ? void 0 : r.extraConf
  });
  return /* @__PURE__ */ g(a, { $additionnalstyle: h, children: [
    f && (r == null ? void 0 : r.titlePartOverrides) && Object.values(r.titlePartOverrides).filter((R) => !j.isEmpty(R)).length > 0 && /* @__PURE__ */ t($, { children: r.metricAlias }),
    x && /* @__PURE__ */ t(
      l,
      {
        iconSpan: p,
        value: r,
        timeInterval: d,
        dayDifference: e,
        setActiveKey: i,
        iconSize: s,
        onDelete: o
      }
    ),
    w && /* @__PURE__ */ t(
      G,
      {
        iconSpan: p,
        value: r,
        setActiveKey: i,
        iconSize: s,
        onDelete: o
      }
    ),
    c && /* @__PURE__ */ t(
      C,
      {
        iconSpan: p,
        value: r,
        setActiveKey: i,
        iconSize: s,
        onDelete: o
      }
    ),
    P && !n && /* @__PURE__ */ t(
      E,
      {
        iconSpan: p,
        value: r,
        setActiveKey: i,
        iconSize: s,
        onDelete: o
      }
    )
  ] });
}), $ = m.div`
  color: var(--medium-grey)
`, a = m(A)`
    gap: 4px;
    line-height: 16px;
    * {
        font-size: 12px;
    }
    ${({ $additionnalstyle: r }) => r}
`;
export {
  T as default
};
//# sourceMappingURL=MetricOptionsResume.js.map
